<template>
  <div class="flex -mx-3">
    <div class="w-24 px-3" />
    <div class="flex-1 px-3">Name</div>
    <div v-if="$isAdminOrSuperAdmin" class="flex-1 px-3">Membership product</div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratHeader',
};
</script>
